import { useEffect, useRef, useState } from 'react';

// @Utility
import setBodyScroll from "@utility/app/setBodyScroll";

// Redux & Action
import { useSelector, useDispatch } from 'react-redux';
import { openAuthenApp } from "@core/redux/actions/auth/index";
import { authentication } from "@core/redux/actions/auth/index";

// JWT & Auth
import { isUserLoggedIn } from "@core/auth/utils";

// Component
import LogoApp from "./../Logo";
import ModalApp from "./../ModalFull";
import ModalAlert from "./../Alert/ModalAlert";
import Grid from '@mui/material/Grid';
import LoginApp from "./Login";
import RegisterApp from "./Register";
import RememberApp from "./Remember";
import SnackbarSet from "./../SnackbarSet";

// Icon
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// Style & CSS
import "assets/css/Input.css";

function AuthApp() {
    const childRef = useRef();
    const auth = useSelector(state => state.reduxAuth);
    const dispatch = useDispatch();
    const [step, setStep] = useState(1);
    // อยู่ระหว่างขั้นตอนยืนยัน OTP ไหม — Register เป็นคนบอกขึ้นมา
    // เก็บใน ref ไม่ใช่ state เพราะไม่ได้ใช้ render และ onShow ต้องอ่านค่าล่าสุดในจังหวะที่ถูกเรียก
    // ตอนยืนยัน OTP สำเร็จ Register ปลดธงแล้วสั่งปิด modal ต่อกันทันที ถ้าเป็น state ค่าจะยังเป็นของเดิม
    // แล้วจะเด้ง "ออกจากขั้นตอนยืนยันรหัส OTP ?" ทั้งที่สมัครสำเร็จไปแล้ว
    const otpProcessRef = useRef(false);
    const setOtpProcess = (val) => {
        otpProcessRef.current = val;
    };
    const [confirmExit, setConfirmExit] = useState(false);

    // เปิดใช้งาน Auth
    const onShow = (val) => {
        // ปิด modal ทิ้งระหว่างยืนยัน OTP = ต้องขอรหัสใหม่ ถามก่อน
        if (val === false && otpProcessRef.current) {
            // ModalFull.close() กับ close() ปลดล็อก scroll ไปก่อนเรียกตัวนี้แล้ว
            // แต่เรายังไม่ได้ปิดจริง ต้องล็อกคืน ไม่งั้นพื้นหลังเลื่อนได้ทั้งที่ modal ยังเปิดอยู่
            setBodyScroll(true);
            setConfirmExit(true);
            return;
        }

        dispatch(openAuthenApp({ ...auth, show: val }));
    };

    // ยืนยันว่าจะออกจริง — modal ปิดแล้ว Register ถูก unmount สถานะ OTP หายไปทั้งชุด
    const leaveOtp = () => {
        setConfirmExit(false);
        setOtpProcess(false);
        setBodyScroll(false);
        dispatch(openAuthenApp({ ...auth, show: false }));
    };

    // เปลีย่นช่องทาง
    const switchChanel = (val) => {
        // setData(undefined)
        dispatch(openAuthenApp({ ...auth, tab: val }));
    };

    const alertMsg = async (da) => {
        childRef.current.snackbar(da);
    }

    // ปิด modal
    const close = () => {
        setBodyScroll(false);
        onShow(false);
    }

    const authenSubmit = (data) => {
        let myJson = {
            "username": data.username,
            "password": data.password,
            "verify": ""
        };

        dispatch(authentication(myJson, close));
    };

    useEffect(() => {

        // ตรวจสอบว่ามีการเข้าสู้ระบบหรือไม่
        if (isUserLoggedIn()) {
            dispatch(openAuthenApp({
                tab: "login",
                show: false
            }));
            setBodyScroll(false);
        }

        setStep(1)
    }, [auth.show, dispatch]);

    return (
        <>
            <SnackbarSet ref={childRef} />
            <ModalApp show={auth.show} onShow={onShow} step={step} onStep={setStep}>
                {
                    auth.tab === "remember" && (
                        <div className="positionRelative">
                            <div className="positionAbsolute backButtonFull" onClick={() => switchChanel("login")}>
                                <ArrowBackIcon className="iconImgFull"></ArrowBackIcon>
                            </div>
                        </div>
                    )
                }

                <div className="center">
                    <LogoApp />
                </div>

                {
                    auth.tab !== "remember" ?
                        <>
                            {auth.tab === "login" ? <LoginApp switchChanel={switchChanel} authenSubmit={authenSubmit} /> : null}
                            {auth.tab === "register" ? <RegisterApp switchChanel={switchChanel} setDataAlert={alertMsg} close={close} onOtpProcess={setOtpProcess} /> : null}
                        </>
                        :
                        <RememberApp onShow={onShow} setDataAlert={alertMsg} switchChanel={switchChanel} />
                }

                <br /><br />
                <div className="inputPaddingTop center">
                    <div style={{ color: "white", fontSize: "16px" }}>
                        Copyright © 2023 supported <br />
                        version 1.0.0
                    </div>
                </div>

            </ModalApp>

            <ModalAlert show={confirmExit} closeBtn={true} onShow={() => setConfirmExit(false)}>
                <div className="boxTitle center" style={{ color: "white" }}>
                    แจ้งเตือน
                </div>

                <div className="contentMarginTop center">
                    <div className="confirmTitle" style={{ color: "white" }}>
                        ออกจากขั้นตอนยืนยันรหัส OTP ?
                        <br />
                        รหัสที่ส่งไปแล้วจะใช้ไม่ได้ ต้องเริ่มขอรหัสใหม่
                    </div>
                </div>

                <div className="boxMarginTop">
                    <Grid container spacing={1} justifyContent="center">
                        <Grid item xs={6}>
                            <div className="center">
                                <button className="btn btnConfirm btnHover btnWidthFull btnRadius textBoldHight" onClick={() => setConfirmExit(false)}>
                                    กรอกรหัสต่อ
                                </button>
                            </div>
                        </Grid>
                        <Grid item xs={6}>
                            <div className="center">
                                <button className="btn btnLogin btnHover btnWidthFull btnRadius textBoldHight" onClick={leaveOtp}>
                                    ออก
                                </button>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </ModalAlert>
        </>
    );
}

export default AuthApp
